import { render, staticRenderFns } from "./SnmodifyPrice.vue?vue&type=template&id=08452e19&"
import script from "./SnmodifyPrice.vue?vue&type=script&lang=js&"
export * from "./SnmodifyPrice.vue?vue&type=script&lang=js&"
import style0 from "./SnmodifyPrice.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports